import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deletePrimaryImage, getEditProjectById } from "../utils/api";

export const fetchProjectById = createAsyncThunk(
  'project/fetchProjectById',
  async ({accessToken, id}, thunkAPI) => {
    const response = await getEditProjectById(accessToken, id);

    if (!response.data.success) {
      throw new Error('Failed to fetch project');
    }

    return response.data;
  }
);

export const deleteProjectFile = createAsyncThunk(
  'project/deleteProjectFile',
  async ({ accessToken, url, type }, thunkAPI) => {
    try {
      await deletePrimaryImage(accessToken, url, type); 

      const state = thunkAPI.getState();
      const files = state.editProject.projectData.files;

      return files.filter((file) => file.url !== url);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const editProjectSlice = createSlice({
  name: 'project',
  initialState: {
    projectData: {
      files: [],
      template_file: null,
    },
    loading: false,
    error: null,
  },
  reducers: {
    setTemplateFile(state, action) {
      state.projectData.template_file = action.payload;
    },
    setPrimaryImages(state, action) {
      state.projectData.files = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectById.fulfilled, (state, action) => {
        state.loading = false;
        state.projectData = action.payload.data[0];
      })
      .addCase(fetchProjectById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteProjectFile.fulfilled, (state, action) => {
        state.projectData.files = action.payload;
      })
      .addCase(deleteProjectFile.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { setTemplateFile, setPrimaryImages } = editProjectSlice.actions;
export default editProjectSlice.reducer;
